// Copyright 2026, University of Maryland, All Rights Reserved
import { registerRendererComponent } from '@/app-shell/renderer-components'
import { SrmFindingsRenderer } from './SrmFindingsRenderer'
import { SrmExpeditedReviewRenderer } from './SrmExpeditedReviewRenderer'

registerRendererComponent({
  id: 'srm-findings',
  label: 'SRM Findings',
  group: 'SRM',
  versionMode: 'aggregate',
  slots: [
    {
      key: 'findings',
      type: 'dataset',
      required: true,
      label: 'Findings',
      description: 'Track findings dataset (e.g. srm.privacy_findings) aggregated across the request\'s documents.',
    },
  ],
  Component: SrmFindingsRenderer,
})

registerRendererComponent({
  id: 'srm-expedited-review',
  label: 'SRM Expedited Privacy Review',
  group: 'SRM',
  versionMode: 'aggregate',
  // The determination is meaningful with zero findings, and the terms half explains its own
  // empty state from the verdict — so the track must always render rather than hide on a
  // zero count.
  contentKind: 'summary',
  slots: [
    {
      key: 'eligibility',
      type: 'dataset',
      required: true,
      label: 'Eligibility',
      description: 'Expedited eligibility dataset: overall determination plus the per-criterion audit trail.',
    },
    {
      key: 'findings',
      type: 'dataset',
      required: true,
      label: 'Vendor Terms Findings',
      description: 'Terms findings dataset, produced only for requests the determination cleared.',
    },
  ],
  Component: SrmExpeditedReviewRenderer,
})
